import { Component, createRef } from "react";
import HeaderHotsite from "./components/HeaderHotsite";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Toast } from 'primereact/toast'
import FooterHotsite from "./components/FooterHotsite";
import imagemBanner from '../../images/banner.png';
import Foto1 from '../../images/foto1.png';
import Foto2 from '../../images/foto2.png';
import Pessoa1 from '../../images/pessoa1.jpg';
import Pessoa2 from '../../images/pessoa2.jpeg';
import Pessoa3 from '../../images/pessoa3.jpg';

import Pessoa from 'lirida-back-service/Servicos/Pessoa/Pessoa';
import Documento from 'lirida-back-service/Servicos/Documento/Documento';
import DocumentoItem from "lirida-back-service/Servicos/Documento/DocumentoItem";
import DocumentoService from 'lirida-back-service/Servicos/Documento/DocumentoService';
import PessoaService from 'lirida-back-service/Servicos/Pessoa/PessoaService';
import Util from '../../util/Util';
import Constante from '../../util/Constante';
import Pesquisa from 'lirida-back-service/Servicos/Pesquisa/Pesquisa'
import TabelaPrecoItem from "lirida-back-service/Servicos/TabelaPrecoItem/TabelaPrecoItem";
import TabelaPrecoService from "lirida-back-service/Servicos/TabelaPreco/TabelaPrecoService";
import DocumentoRelacionamento from "lirida-back-service/Servicos/DocumentoRelacionamento/DocumentoRelacionamento";
import DocumentoItemRelacionamento from "lirida-back-service/Servicos/DocumentoItemRelacionamento/DocumentoItemRelacionamento";

export default class Hotsite extends Component {

  toast = createRef();
  constante = new Constante();
  util = new Util(this.constante.token, this.constante.url_base);
  documentoService = new DocumentoService(this.constante.token, this.constante.url_base);
  pessoaService = new PessoaService(this.constante.token, this.constante.url_base);
  tabelaPrecoService = new TabelaPrecoService(this.constante.token, this.constante.url_base);

  state = {
    pessoaCliente: new Pessoa(),
    pessoaCondominio: new Pessoa(),
    documento: new Documento(),
    tabelaPrecoItem: new TabelaPrecoItem(),
    documentoItem: new DocumentoItem(),
    carregando: false,

    //LISTAS
    listaCondominio: [],
    listaTabelaPrecoItem: [],

    inputError: {
      nome: false,
      documento: false,
      telefone: false,
      email: false,
      localServico: false,
      quantidade: false,
      sala: false,
      dataAgendamento: false,
    }
  }

  componentDidMount() {
    this.iniciar()
  }

  async iniciar() {
    let listaPesquisa = []

    let pesquisa = new Pesquisa();
    pesquisa.campo = 'pessoa.seq_usuario';
    pesquisa.conteudo = this.constante.seqUsuario;
    pesquisa.operacao = '';
    pesquisa.tipo = 'TEXTO';
    listaPesquisa.push(pesquisa);

    pesquisa = new Pesquisa();
    pesquisa.campo = 'pessoa.seq_pessoa_perfil';
    pesquisa.conteudo = this.constante.seqPessoaPerfilCondominio;
    pesquisa.operacao = 'AND';
    pesquisa.tipo = 'TEXTO';
    listaPesquisa.push(pesquisa);
    let retorno = await this.pessoaService.listarComFiltro(listaPesquisa);
    let listaCondominio = retorno.objeto

    let retornoListaTabelaPrecoItem = await this.tabelaPrecoService.listarItem(this.constante.seqTabelaPrecoPadrao, '', 'S', '');
    let listaTabelaPrecoItem = retornoListaTabelaPrecoItem.objeto;

    this.setState({
      listaCondominio: listaCondominio,
      listaTabelaPrecoItem: listaTabelaPrecoItem,
    })

  }

  async salvar() {
    let inputError = this.state.inputError;
    let documento = this.state.documento;
    let pessoaCliente = this.state.pessoaCliente;
    let pessoaCondominio = this.state.pessoaCondominio;
    let documentoItem = this.state.documentoItem;
    let tabelaPrecoItem = this.state.tabelaPrecoItem;
    let inputsOK = true;

    Object.keys(inputError).forEach(pKey => {
      inputError[pKey] = false;
    });

    if (!pessoaCliente.nome) {
      inputError.nome = true;
    }

    if (!pessoaCliente.documento) {
      inputError.documento = true;
    }

    if (!pessoaCliente.telefonePlataformaLirida) {
      inputError.telefone = true;
    }

    if (!pessoaCliente.emailPlataformaLirida) {
      inputError.email = true;
    }

    if (!pessoaCondominio._seqPessoa) {
      inputError.localServico = true;
    }

    if (!tabelaPrecoItem._seqTabelaPrecoItem) {
      inputError.quantidade = true;
    }

    if (!documentoItem.tags2) {
      inputError.sala = true;
    }

    if (!documento.dataProgramada) {
      inputError.dataAgendamento = true;
    }

    Object.keys(inputError).forEach(pKey => {
      if (inputError[pKey]) {
        inputsOK = false;
      }
    });

    if (!inputsOK) {
      this.setState({
        inputError: inputError,
      });
      return;
    }


    pessoaCliente.seqUsuario = this.constante.seqUsuario;
    pessoaCliente.seqPessoaPerfil = this.constante.seqPessoaPerfilCliente;
    pessoaCliente.seqTabelaPreco = this.constante.seqTabelaPrecoPadrao;

    if (pessoaCliente.documento.length === 14) {
      pessoaCliente.tipoDocumento = 'CPF';
    }

    if (pessoaCliente.documento.length === 18) {
      pessoaCliente.tipoDocumento = 'CNPJ';
    }

    this.setState({ carregando: true })

    let retornoPessoa = await this.pessoaService.salvar(pessoaCliente);
    pessoaCliente = retornoPessoa.objeto;


    //SALVANDO DOCUMENTO//
    documento.dataProgramada = this.util.formatarDataBanco(documento.dataProgramada)
    documento.seqUsuario = this.constante.seqUsuario;
    documento.seqTipoDocumento = this.constante.seqTipoDocumento;
    documento.seqPessoa = pessoaCliente._seqPessoa;
    documento.seqTipoDocumentoProcesso = this.constante.seqTipoDocumentoProcessoNaoAgendado;
    documento.seqContaBancaria = this.constante.seqContaBacariaPrincipal;
    documento.seqCondicaoPagamento = this.constante.seqCondicaoPagamentoAVista;
    documento.seqFormaPagamento = this.constante.seqFormaPagamentoPix;
    documento.seqPessoaRecebedor = this.constante.seqPessoaRecebedor;
    documento.seqContaFinanceira = this.constante.seqPlanoDeContaFinanceiroAnalitica;
    documento.seqPeriodo = this.constante.seqPeriodo;
    documento.valorTotal = tabelaPrecoItem.precoMaximo;
    documento.seqEndereco = pessoaCondominio.seqEnderecoPrincipal;

    let retornoDocumento = await this.documentoService.salvar(documento);
    documento = retornoDocumento.objeto;

    //SALVANDO RELACIONAMENTO DO CLIENTE
    let documentoRelacionamento = new DocumentoRelacionamento();
    documentoRelacionamento.seqUsuario = this.constante.seqUsuario;
    documentoRelacionamento.seqTipoRelacionamento = this.constante.seqTipoRelacionamentoSolicitante;
    documentoRelacionamento.seqPessoaRelacionada = pessoaCliente._seqPessoa;
    documentoRelacionamento.seqDocumento = documento._seqDocumento;

    await this.documentoService.salvarRelacionamento(documentoRelacionamento);

    //SALVANDO RELACIONAMENTO DO LOCAL
    documentoRelacionamento = new DocumentoRelacionamento();
    documentoRelacionamento.seqUsuario = this.constante.seqUsuario;
    documentoRelacionamento.seqTipoRelacionamento = this.constante.seqTipoRelacionamentoLocal;
    documentoRelacionamento.seqPessoaRelacionada = pessoaCondominio._seqPessoa;
    documentoRelacionamento.seqDocumento = documento._seqDocumento;

    await this.documentoService.salvarRelacionamento(documentoRelacionamento);

    let retornoRelacionamento = await this.pessoaService.listarRelacionamento(pessoaCondominio)
    let lider = retornoRelacionamento.objeto[0]
    console.log("lider", lider);

    //SALVANDO RELACIONAMENTO DO LIDER
    let documentoRelacionamentolider = new DocumentoRelacionamento();
    documentoRelacionamentolider.seqUsuario = this.constante.seqUsuario;
    documentoRelacionamentolider.seqTipoRelacionamento = this.constante.seqTipoRelacionamentoLiderResponsavel;
    documentoRelacionamentolider.seqPessoaRelacionada = lider.seqPessoaRelacionada;
    documentoRelacionamentolider.seqDocumento = documento._seqDocumento;

    await this.documentoService.salvarRelacionamento(documentoRelacionamentolider);

    //SALVANDO DOCUMENTO ITEM
    documentoItem.seqUsuario = this.constante.seqUsuario;
    documentoItem.situacao = "ATIVO";
    documentoItem.seqDocumento = documento._seqDocumento;
    documentoItem.seqTipoDocumentoProcesso = this.constante.seqTipoDocumentoProcessoNaoAgendado;
    documentoItem.seqItem = tabelaPrecoItem.seqItem;
    documentoItem.quantidade = 1;
    documentoItem.dataProgramada = documento.dataProgramada;
    documentoItem.precoUnitario = tabelaPrecoItem.preco;
    documentoItem.precoTabela = tabelaPrecoItem.preco;
    documentoItem.precoTabelaMaximo = tabelaPrecoItem.precoMaximo;
    documentoItem.precoTabelaMinimo = tabelaPrecoItem.precoMinimo;
    documentoItem.seqEndereco = pessoaCondominio.seqEnderecoPrincipal;
    documentoItem.tags4 = pessoaCondominio._seqPessoa;
    documentoItem.tags5 = pessoaCondominio.nome;
    documentoItem.tags6 = pessoaCondominio.foto;

    let retornoDocumentoItem = await this.documentoService.salvarItem(documentoItem);
    documentoItem = retornoDocumentoItem.objeto

    //SALVANDO RELACIONAMENTO DOCUMENTO ITEM CLIENTE
    let documentoItemRelacionamento = new DocumentoItemRelacionamento();
    documentoItemRelacionamento.seqUsuario = this.constante.seqUsuario;
    documentoItemRelacionamento.seqTipoRelacionamento = this.constante.seqTipoRelacionamentoSolicitante;
    documentoItemRelacionamento.seqPessoaRelacionada = pessoaCliente._seqPessoa;
    documentoItemRelacionamento.seqDocumentoItem = documentoItem._seqDocumentoItem;

    await this.documentoService.salvarRelacionamentoItem(documentoItemRelacionamento);

    //SALVANDO RELACIONAMENTO DOCUMENTO ITEM LOCAL
    documentoItemRelacionamento = new DocumentoItemRelacionamento();
    documentoItemRelacionamento.seqUsuario = this.constante.seqUsuario;
    documentoItemRelacionamento.seqTipoRelacionamento = this.constante.seqTipoRelacionamentoLocal;
    documentoItemRelacionamento.seqPessoaRelacionada = pessoaCondominio._seqPessoa;
    documentoItemRelacionamento.seqDocumentoItem = documentoItem._seqDocumentoItem;

    await this.documentoService.salvarRelacionamentoItem(documentoItemRelacionamento);

    //SALVANDO RELACIONAMENTO DOCUMENTO ITEM LIDER    
    let documentoItemRelacionamentoLider = new DocumentoItemRelacionamento();
    documentoItemRelacionamentoLider.seqUsuario = this.constante.seqUsuario;
    documentoItemRelacionamentoLider.seqTipoRelacionamento = this.constante.seqTipoRelacionamentoLiderResponsavel;
    documentoItemRelacionamentoLider.seqPessoaRelacionada = lider.seqPessoaRelacionada;
    documentoItemRelacionamentoLider.seqDocumentoItem = documentoItem._seqDocumentoItem;

    await this.documentoService.salvarRelacionamentoItem(documentoItemRelacionamentoLider);


    documento.observacao =
      `Essa cobrança é referente a plataforma: Faxina Rápida (faxinarapida.com.br)

      Condomínio: ${pessoaCondominio.nome}
      Sala: ${documentoItem.tags2}
      Quantidade: ${documentoItem.quantidade}
      Agendado para: ${documentoItem.dataProgramada}

      A nota fiscal será emitida após a execução do serviço.`

    retornoDocumento = await this.documentoService.salvar(documento);
    documento = retornoDocumento.objeto;





    //GERANDO FINANCEIRO
    // let retornoFinanceiro = await this.documentoService.gerarMovimentoFinanceiro(documento);
    // let financeiro = retornoFinanceiro.objeto;

    // window.open(this.constante.url_base_crosspag + financeiro._seqMovimentoFinanceiro);

    // this.util.enviarEmailConfirmarPedido(pessoaCliente.emailPlataformaLirida, pessoaCliente.nome, financeiro._seqMovimentoFinanceiro);

    this.toast.current.show({
      severity: 'success', summary: "Pedido enviado!", sticky: true,
    })

    this.setState({
      pessoaCliente: new Pessoa(),
      pessoaCondominio: new Pessoa(),
      tabelaPrecoItem: new TabelaPrecoItem(),
      documentoItem: new DocumentoItem(),
      documento: new Documento(),
      carregando: false,
    })
  }


  render() {
    return <>
      <Toast ref={this.toast} style={{ marginTop: '10%' }} />

      <HeaderHotsite />

      <main className="h-main-container">
        <img className="h-slide-img" src={imagemBanner} alt="imagem principal" />
        <div className="h-sobre">
          <section className="h-sobre-container" id="sobre">
            <div>
              <i className="pi pi-building" style={{ fontSize: 30 }}></i>
              <h2>Quem somos</h2>
              <p>
                O Faxina Rápida é a solução que veio para conectar você que precisa de um serviço de limpeza a profissionais capacitados, treinados e de confiança para cuidar e fazer a limpeza do seu ambiente de trabalho
              </p>
            </div>
            <div>
              <i className="pi pi-cog" style={{ fontSize: 30 }}></i>
              <h2>Como funciona</h2>
              <p>
                Apenas preenchendo o formulário e aguardando a sua faxina ir até você! Não é mais necessário contratar pessoas fixas para fazer a faxina, contrate um profissional para fazer a sua faxina!
              </p>
            </div>
            <div>
              <i className="pi pi-users" style={{ fontSize: 30 }}></i>
              <h2>Para quem</h2>
              <p>
                Feito para você que não tem tempo para perder limpando, feito pra você que precisa de um profissional capacitado para fazer sua faxina com rapidez e qualidade! A limpeza do seu escritório ou espaço de trabalho é mais importante!
              </p>
            </div>
          </section>
        </div>

        <div className="h-func">
          <section className="h-func-container" id="funcionalidades">
            <div>
              <p>
                Encontre um profissional de faxina mais perto de você com poucos cliques
              </p>
              <img src={Foto1} alt="imagem flutuante" />
            </div>

            <div>
              <p>
                Sua faxina vai até você!! Conforto e confiança à 100%!!
              </p>
            </div>

            <div>
              <img src={Foto2} alt="imagem flutuante" />
              <p>
                Rapidez e praticidade na palma da sua mão! Chame agora o seu/sua “Faxineiro(a)”
              </p>
            </div>
          </section>
        </div>


        <div className="h-depo">
          <section className="h-depo-container" id="depoimentos">
            <div>
              <img src={Pessoa1} alt="foto pessoa" />
              <div>
                <h2>
                  Fernando (Cliente)
                </h2>
                <p>
                  “Depois que descobrir o Faxina Rápida não quero mais outra coisa. Sempre que preciso tem um profissional na minha região para me atender”
                </p>
              </div>
            </div>

            <div>
              <img src={Pessoa2} alt="foto pessoa" />
              <div>
                <h2>
                  Viviane (Cliente)
                </h2>
                <p>
                  “Trabalho muito e não tenho tempo para limpar meu escritório. Sorte que tenho Faxina Rápida para fazer a minha faxina semanal!”
                </p>
              </div>
            </div>

            <div>
              <img src={Pessoa3} alt="foto pessoa" />
              <div>
                <h2>
                  Joel (Empreendedor)
                </h2>
                <p>
                  “Agora que trabalho pelo Faxina Rápida recebo o justo! Larguei a uber e outras formas de trabalho. Faxina Rápida agora virou minha renda principal, são muitos trabalhos!”
                </p>
              </div>
            </div>
          </section>
        </div>


        <section className="h-faq-container-formulario" id='Formulario'
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "lightgray",
          }} >

          <h2 className="h-titulo-underline" style={{ textAlign: 'center' }}>
            Sua faxina a poucos cliques de você!! Peça agora!
          </h2>

          <form onSubmit={pEvento => { pEvento.preventDefault(); this.salvar(); }}
            style={{
              width: 500,
              height: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 20, borderRadius: 20,
              backgroundColor: 'white',
              alignItems: "center",
              padding: "10px",
              boxShadow: " 5px 10px 8px 5px gray",
              border: "1px solid gray "

            }} >

            <div style={{ width: "90%", marginTop: 20 }}>
              <label>Nome</label><br />
              <InputText
                onChange={(pEvento) => this.setState({
                  pessoaCliente: {
                    ...this.state.pessoaCliente,
                    nome: pEvento.target.value
                  }
                })}
                style={{ width: '100%', borderColor: this.state.inputError.nome && 'red' }}
                value={this.state.pessoaCliente.nome || ""}
                placeholder='Seu nome completo'
              />
              {this.state.inputError.nome && <small style={{ color: 'red' }}>Nome inválido</small>}
            </div>

            <div style={{ width: "90%" }}>
              <label>CPF/CNPJ</label><br />
              <InputText
                onChange={(pTexto) => this.setState({
                  pessoaCliente: {
                    ...this.state.pessoaCliente,
                    documento: this.util.formatarCPFCNPJ(pTexto.target.value)
                  }
                })}
                style={{ width: '100%', borderColor: this.state.inputError.documento && 'red' }}
                type='tel'
                value={this.state.pessoaCliente.documento || ""}
                placeholder='000.000.00-00' />
              {this.state.inputError.documento && <small style={{ color: 'red' }}>Documento inválido</small>}
            </div>

            <div style={{ width: "90%" }}>
              <label>Telefone</label><br />
              <InputText
                onChange={pEvento => this.setState({
                  pessoaCliente: {
                    ...this.state.pessoaCliente,
                    telefonePlataformaLirida: this.util.formatarTelefone(pEvento.target.value)
                  }
                })}
                placeholder='(00) 00000-0000'
                style={{ width: '100%', borderColor: this.state.inputError.telefone && 'red' }}
                type={'tel'}
                value={this.state.pessoaCliente.telefonePlataformaLirida || ""} />
              {this.state.inputError.telefone && <small style={{ color: 'red' }}>Telefone inválido</small>}
            </div>

            <div style={{ width: "90%" }}>
              <label>E-mail</label><br />
              <InputText
                onChange={(pTexto) => this.setState({
                  pessoaCliente: {
                    ...this.state.pessoaCliente, emailPlataformaLirida: pTexto.target.value
                  }
                })}
                placeholder='email@email.com'
                style={{ width: '100%', borderColor: this.state.inputError.email && 'red' }}
                type='email'
                value={this.state.pessoaCliente.emailPlataformaLirida || ""} />
              {this.state.inputError.email && <small style={{ color: 'red' }}>Email inválido</small>}
            </div>

            <div style={{ width: "90%" }}>
              <label>local de serviço</label><br />
              <Dropdown
                onChange={pEvento => this.setState({
                  pessoaCondominio: pEvento.value
                })}
                value={this.state.pessoaCondominio}
                options={this.state.listaCondominio}
                optionLabel={'nome'}
                style={{ width: '100%', borderColor: this.state.inputError.localServico && 'red' }}
                placeholder='Selecione' />
              {this.state.inputError.localServico && <small style={{ color: 'red' }}>Local de serviço inválido</small>}
            </div>
            <div style={{ width: "90%" }}>
              <label>Selecione a quantidade </label><br />
              <Dropdown
                onChange={pEvento => this.setState({
                  tabelaPrecoItem: pEvento.target.value
                })}
                value={this.state.tabelaPrecoItem}
                options={this.state.listaTabelaPrecoItem}
                optionLabel={'_itemNome'}
                style={{ width: '100%', borderColor: this.state.inputError.quantidade && 'red' }}
                placeholder='Selecione' />
              {this.state.inputError.quantidade && <small style={{ color: 'red' }}>Quantidade inválida</small>}
            </div>

            <div style={{ width: "90%" }}>
              <label>Bloco / Sala</label><br />
              <InputText
                onChange={pEvento => this.setState({
                  documentoItem: {
                    ...this.state.documentoItem,
                    tags2: pEvento.target.value
                  }
                })}
                placeholder='Exemplo: Bloco 01 / Sala 404'
                style={{ width: '100%', borderColor: this.state.inputError.sala && 'red' }}
                type='text'
                value={this.state.documentoItem.tags2 || ""}
              />
              {this.state.inputError.sala && <small style={{ color: 'red' }}>Bloco / Sala inválida</small>}
            </div>

            <div style={{ width: "90%" }}>
              <label>Data agendamento</label><br />
              <Calendar
                onChange={pEvento => this.setState({
                  documento: {
                    ...this.state.documento,
                    dataProgramada: pEvento.target.value
                  }
                })}
                showButtonBar
                dateFormat="dd/mm/yy"
                placeholder="dd/mm/yyyy"
                value={this.state.documento.dataProgramada}
                style={{ width: '100%', borderColor: this.state.inputError.dataAgendamento && 'red' }}
                inputStyle={{ width: '100%', borderColor: this.state.inputError.dataAgendamento && 'red' }}

              />
              {this.state.inputError.dataAgendamento && <small style={{ color: 'red' }}>Data de agendamento inválido</small>}
            </div>

            <Button label="Salvar" type="submit" loading={this.state.carregando} style={{ width: "90%", borderRadius: 50, backgroundColor: "#2D7D86" }} />


          </form>
        </section>

        <section className="h-faq-container" id="perguntas-frequentes">
          <h2>Perguntas frequentes</h2>

          <Accordion multiple>
            <AccordionTab header="Preciso pagar alguma mensalidade para usar a plataforma?">
              <p>
                Não, para utilizar nossa plataforma e ter acesso aos recursos é totalmente livre de mensalidade.
              </p>
            </AccordionTab>
            <AccordionTab header="Depois que criei a conta, posso editar minhas informações?">
              <p>
                Sim, suas informações ficam disponíveis para edição quando você quiser.
              </p>
            </AccordionTab>
            <AccordionTab header="Como faço para me cadastrar na plataforma?">
              <p>
                Entre em contato conosco no email atendimento@faxinex.com.br
              </p>
            </AccordionTab>
            <AccordionTab header="Eu posso cancelar ou excluir minha conta?">
              <p>
                Sim, você tem total autonomia e controle sobre sua conta A qualquer momento você exclui sua sem custo nenhum.
              </p>
            </AccordionTab>
            <AccordionTab header="Preciso passar por alguma análise?">
              <p>
                Sim, buscamos levar o melhor atendimento para os clientes, assim para manter a segurança e qualidade dos serviços é preciso que o profissional passe por uma análise.
              </p>
            </AccordionTab>
          </Accordion>
        </section>
      </main>

      <FooterHotsite />

    </>


  }
}